import { render, staticRenderFns } from "./Atletas.vue?vue&type=template&id=0dbab8da&scoped=true&"
import script from "./Atletas.vue?vue&type=script&lang=js&"
export * from "./Atletas.vue?vue&type=script&lang=js&"
import style0 from "./Atletas.vue?vue&type=style&index=0&id=0dbab8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbab8da",
  null
  
)

export default component.exports